import parseOptionalQuestions from 'utils/pivot/compliance/parseOptionalQuestions'
import parseDisclosures from 'utils/pivot/compliance/parseDisclosures'
import parseDisclaimers from 'utils/pivot/compliance/parseDisclaimers'
import parseAgreements from 'utils/pivot/compliance/parseAgreements'
import parseQuestions from 'utils/pivot/compliance/parseQuestions'
import parseTerms from 'utils/pivot/compliance/parseTerms'
import getSignatureDocument, {
  type GetSignatureDocumentParams
} from 'core/services/getSignatureDocument'

const parseHcStorage = (hcStorage, documentId) => {
  return {
    ...hcStorage,
    pivotPlan: hcStorage.pivotPlan[0],
    esignatureDocument: {
      ...hcStorage.esignatureDocument,
      documentId // Ensure the documentId is updated in the hcStorage. Sometimes the documentId is not present in the hcStorage based on the flow
    }
  }
}

async function getAndParseDocument(params: GetSignatureDocumentParams) {
  const signatureDocumentResult = await getSignatureDocument(params)

  if (!signatureDocumentResult) {
    return [new Error('No data found'), undefined]
  }

  if (signatureDocumentResult.error) {
    return [signatureDocumentResult.error, undefined]
  }

  const { hcState, compliance, ...restResponse } = signatureDocumentResult
  const { terms, agreements, disclosures, questions, optionalQuestions, disclaimers } =
    compliance || {}

  const signatureDocument = {
    ...restResponse,
    hcStorage: parseHcStorage(hcState, params.documentId),
    compliance: {
      terms: parseTerms(terms),
      agreements: parseAgreements(agreements),
      disclosures: parseDisclosures(disclosures),
      questions: parseQuestions(questions),
      optionalQuestions: parseOptionalQuestions(optionalQuestions),
      disclaimers: parseDisclaimers({ disclaimers })
    }
  }

  return [undefined, signatureDocument]
}

export default getAndParseDocument
